import React from "react";
import { isFunction } from "lodash";
import { useQuery, useLazyQuery, useMutation } from "@apollo/client";
import { GET_LOCATIONS } from "../graphql/query";
import { UPDATE_LOCATION } from "../graphql/mutation";

const useLocation = ({
  variables = {},
  skip = false,
  fetchPolicy = "network-only",
  successCallback,
} = {}) => {
  // Standard query
  const { data, loading, error, refetch } = useQuery(GET_LOCATIONS, {
    variables,
    skip,
    fetchPolicy,
    onCompleted: res => {
      if (isFunction(successCallback)) {
        successCallback(res?.getLocations || []);
      }
    },
  });

  // Lazy query
  const [
    fetchLocations,
    { data: lazyData, loading: lazyLoading, error: lazyError, refetch: lazyRefetch },
  ] = useLazyQuery(GET_LOCATIONS);

  // Update location mutation
  const [
    updateLocation,
    { loading: updateLoading, error: updateError, client: updateLocationClient },
  ] = useMutation(UPDATE_LOCATION);

  return {
    data,
    loading,
    error,
    refetch,
    fetchLocations,
    lazyData,
    lazyLoading,
    lazyError,
    lazyRefetch,
    updateLocation,
    updateLoading,
    updateError,
    updateLocationClient,
  };
};

export default useLocation;
